import { useReducedMotion } from 'motion-v'
import { computed } from 'vue'

/** Shared by drawer slots and the platform shell so their layout changes stay together. */
export function useDrawerTransition() {
  const reducedMotion = useReducedMotion()
  return computed(() => ({
    type: 'tween' as const,
    duration: reducedMotion.value ? 0 : 0.3,
    ease: 'easeInOut' as const,
  }))
}
